import React, { useEffect, useState } from "react";
import "../style.css";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { updatedDetail } from "../../../../store/actions/precog";
import CurrencyChoice from "../../../general/currencyChoice";

const CardTotalEditable = ({
  amount,
  isCreate,
  isTax,  
  newDetail,
  setNewDetail,
  totalTaxable,
  totalTax
}) => {

  const source = useSelector(state => state.precog.invoiceDetail?.data?.source);
  const jsonCurrency = useSelector(state => state?.currencyList?.currencies);
  const dispatch = useDispatch();

  const [totalValue, setTotalValue] = useState(0);

  useEffect(() => {
    setTotalValue(newDetail?.amount || 0);
  }, [newDetail?.amount]);
  
  /**
   * Quando si è in creazione la card cambia leggermente
   */
  return (
    <div className="pre-cog-detail-header-total-card">
      <div style={{ padding: 16, borderBottom: "1px solid #c9d9e8" }}>
        <div className="pre-cog-detail-header-total-title"
          style={isCreate ? {color: "rgb(0, 80, 117)",
            fontFamily: "Cairo", fontWeight: "500",
            fontSize: "16px"} : {}}
        >
          <FormattedMessage id={ isCreate || source==="MANUAL" ? "preCog.header.documentTotal" : "preCog.header.docTotal"} />
        </div>

        <div style={{display: "flex", alignItems: "center"}}>
          <NumberFormat
            allowEmptyFormatting={false}
            allowLeadingZeros={true}
            displayType={"input"}
            thousandSeparator={"."}
            decimalSeparator={","}
            className={(!amount || numeral(Math.abs(amount)) === 0) ? "totalMovimentInput " : "totalMovimentInput"}
            placeholder={"- " + jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol}
            suffix={" " + jsonCurrency?.[newDetail?.refCurrency || "EUR"]?.symbol}          
            onKeyDown={(event) => {              
              if (event.key === "Enter"){                
                event.currentTarget.blur();
              } 
            }}
            style={{textAlign: "right"}}
            value={totalValue ? numeral(totalValue).format("0,0.00") : null}
            onBlur={() => dispatch(updatedDetail(newDetail?.id,
              {
                amount: totalValue,
                refCurrency: newDetail?.refCurrency || "EUR"
              })).then(res => {
              // setLastUpdate(moment());
              // invio anche la refCurrency nel caso sia vuota la setta a default a EUR
              setNewDetail({...newDetail, amount: totalValue, refCurrency: newDetail?.refCurrency || "EUR"});
            }).catch(err => console.log(err))}
            onValueChange={el => {
              setTotalValue(el.floatValue);
            }
            }
          />
          <CurrencyChoice newDetail={newDetail} onChangeCurrency={setNewDetail}
            activeCurrency={newDetail?.refCurrency || "EUR"} />
        </div>
      </div>
      { isTax && 
         <div style={{ padding: 16 }}>
           <div className="pre-cog-detail-header-taxable">
             <div className="pre-cog-detail-header-taxable-text">
               <FormattedMessage id="preCog.header.taxable" />
             </div>
             <div className="pre-cog-detail-header-taxable-amount">
               {totalTaxable ? numeral(Math.abs(totalTaxable)).format("0,0.00") : "0,00"} €
             </div>
           </div>

           <div className="pre-cog-detail-header-taxable">
             <div className="pre-cog-detail-header-taxable-text">
               <FormattedMessage id="preCog.header.tax" />
             </div>
             <div className="pre-cog-detail-header-taxable-amount">
               {totalTax ? numeral(Math.abs(totalTax)).format("0,0.00") : "0,00"} €
             </div>
           </div>
         </div>
      }
    </div>
  );
};

export default CardTotalEditable;
